import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ProductPage() {
  const [selectedColor, setSelectedColor] = useState('black');
  const [quantity, setQuantity] = useState(1);
  const [activeImage, setActiveImage] = useState(0);
  const [activeTab, setActiveTab] = useState('description');
  const [showNotification, setShowNotification] = useState(false);
  const [sliderPosition, setSliderPosition] = useState(50);
  const [showStickyCart, setShowStickyCart] = useState(false);
  const sliderRef = useRef<HTMLDivElement>(null);
  const addToCartRef = useRef<HTMLDivElement>(null);

  const colors = [
    { name: 'black', label: 'Black', hex: '#1a1a1a' },
    { name: 'blue', label: 'Blue', hex: '#2563eb' },
  ];
  
  const images = [
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/badb2f3f49cae46b24967f0ed3d3f836.jpeg',
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/bf1e3d2c475de4f9214add6d2ee1fbda.jpeg',
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/a435648e8b82f553df4e66ed18185fa3.png',
    'https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/5865f6d8b2057bce0e5908ddee4cea9c.png',
  ];

  const reviews = [
    { name: 'Marcus T.', rating: 5, date: '2 weeks ago', text: 'Been using this for 3 weeks now. Comfortable enough to sleep in and I wake up with my mouth closed. Simple but effective.', verified: true },
    { name: 'James K.', rating: 5, date: '1 month ago', text: 'Quality is impressive. The material is breathable and doesn\'t irritate my skin. Exactly what I was looking for.', verified: true },
    { name: 'David R.', rating: 4, date: '1 month ago', text: 'Good product, took a few nights to get used to but now it\'s part of my routine. Solid build quality.', verified: true },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (addToCartRef.current) {
        const rect = addToCartRef.current.getBoundingClientRect();
        setShowStickyCart(rect.bottom < 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAddToCart = () => {
    if (selectedColor === 'black') {
      window.location.href = 'https://1e6x7u-5j.myshopify.com/cart/63258941751645:1?channel=buy_button';
    } else {
      window.location.href = 'https://1e6x7u-5j.myshopify.com/cart/63258941784413:1?channel=buy_button';
    }
  };

  const handleSliderMove = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
    if (!sliderRef.current) return;
    
    const rect = sliderRef.current.getBoundingClientRect();
    let clientX: number;
    
    if ('touches' in e) {
      clientX = e.touches[0].clientX;
    } else {
      clientX = e.clientX;
    }
    
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setSliderPosition(percentage);
  };

  const handleMouseDown = () => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sliderRef.current) return;
      const rect = sliderRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
      setSliderPosition(percentage);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar variant="solid" />
      
      {/* Sticky Add to Cart Bar */}
      <div className={`fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-black/10 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] transition-all duration-300 ${showStickyCart ? 'translate-y-0' : 'translate-y-full'}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 md:py-4">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 md:gap-4">
              <img 
                src={images[0]} 
                alt="Jawsthe™ NightForm" 
                className="w-12 h-12 md:w-14 md:h-14 rounded-lg object-cover object-top"
              />
              <div className="hidden sm:block">
                <h3 className="text-sm font-semibold">Jawsthe™ NightForm</h3>
                <p className="text-xs text-black/50">€29 · {colors.find(c => c.name === selectedColor)?.label}</p>
              </div>
            </div>
            <button 
              onClick={handleAddToCart}
              className="flex-1 sm:flex-none sm:w-auto h-12 md:h-14 px-6 md:px-10 bg-gradient-to-r from-black to-black/90 text-white rounded-xl font-semibold text-sm uppercase tracking-wider hover:from-black/90 hover:to-black hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer whitespace-nowrap shadow-xl"
            >
              <span className="flex items-center justify-center gap-2">
                <i className="ri-shopping-bag-line text-lg"></i>
                <span className="hidden sm:inline">Add to Cart —</span> €{29 * quantity}
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Notification */}
      <div className={`fixed top-24 right-4 md:right-8 z-50 bg-black text-white px-4 md:px-6 py-3 md:py-4 rounded-lg shadow-xl transition-all duration-300 ${showNotification ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8 pointer-events-none'}`}>
        <div className="flex items-center gap-2 md:gap-3">
          <i className="ri-check-line text-lg md:text-xl text-green-400"></i>
          <span className="text-xs md:text-sm font-medium">Added to cart</span>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="pt-20 md:pt-24 px-4 md:px-20">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-black/50">
            <Link to="/" className="hover:text-black transition-colors cursor-pointer">Home</Link>
            <span>/</span>
            <span className="cursor-pointer hover:text-black transition-colors">Shop</span>
            <span>/</span>
            <span className="text-black">Jawline Support Strap</span>
          </nav>
        </div>
      </div>

      {/* Product Section */}
      <section className="px-4 md:px-20 py-6 md:py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
            {/* Left - Images */}
            <div className="flex flex-col md:flex-row gap-3 md:gap-4">
              {/* Thumbnails */}
              <div className="flex md:flex-col gap-2 md:gap-3 order-2 md:order-1 overflow-x-auto md:overflow-visible">
                {images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveImage(idx)}
                    className={`w-16 h-20 md:w-20 md:h-24 flex-shrink-0 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${activeImage === idx ? 'border-black' : 'border-transparent hover:border-black/20'}`}
                  >
                    <img src={img} alt={`View ${idx + 1}`} className="w-full h-full object-cover object-top" />
                  </button>
                ))}
              </div>
              
              {/* Main Image */}
              <div className="flex-1 aspect-[4/5] rounded-2xl overflow-hidden bg-[#F8F8F8] order-1 md:order-2">
                <img 
                  src={images[activeImage]} 
                  alt="Jawline Support Strap" 
                  className="w-full h-full object-cover object-top transition-opacity duration-300"
                />
              </div>
            </div>

            {/* Right - Product Info */}
            <div className="py-2 md:py-4">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 bg-orange-50 px-3 py-1.5 rounded-full mb-3 md:mb-4">
                <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></span>
                <span className="text-[10px] md:text-[11px] uppercase tracking-wider font-medium text-orange-600">Almost Out of Stock</span>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-3">
                <h1 className="text-2xl md:text-4xl font-semibold tracking-tight text-black">
                  Jawsthe™ NightForm
                </h1>
                <span className="bg-black text-white text-[9px] md:text-[10px] uppercase tracking-wider font-semibold px-2.5 md:px-3 py-1 md:py-1.5 rounded-full w-fit">Bestseller</span>
              </div>
              
              {/* Rating */}
              <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
                <div className="flex items-center gap-1">
                  {[1,2,3,4,5].map(star => (
                    <i key={star} className="ri-star-fill text-black text-xs md:text-sm"></i>
                  ))}
                </div>
                <span className="text-xs md:text-sm text-black/60">4.9 (127 reviews)</span>
              </div>

              {/* Price */}
              <div className="flex items-baseline gap-3 mb-6 md:mb-8">
                <span className="text-2xl md:text-3xl font-semibold">€29</span>
              </div>

              {/* Short Description */}
              <p className="text-sm md:text-[15px] text-black/70 leading-relaxed mb-5 md:mb-6">
                Designed to support proper jaw positioning and encourage nasal breathing during sleep. 
                Premium breathable material for all-night comfort. Suitable for both men and women.
              </p>

              {/* CTA Buttons - More Prominent */}
              <div ref={addToCartRef} className="flex gap-3 md:gap-4 mb-8 md:mb-10">
                <button 
                  onClick={handleAddToCart}
                  className="flex-1 h-14 md:h-16 bg-gradient-to-r from-black to-black/90 text-white rounded-xl font-semibold text-sm md:text-base uppercase tracking-wider hover:from-black/90 hover:to-black hover:scale-[1.02] active:scale-[0.98] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl ring-2 ring-black/5"
                >
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-shopping-bag-line text-lg md:text-xl"></i>
                    Add to Cart — €{29 * quantity}
                  </span>
                </button>
                <button className="w-14 h-14 md:w-16 md:h-16 border-2 border-black/10 rounded-xl flex items-center justify-center hover:border-black/30 hover:bg-black/5 transition-all cursor-pointer">
                  <i className="ri-heart-line text-xl md:text-2xl"></i>
                </button>
              </div>

              {/* Color Selection */}
              <div className="mb-6 md:mb-8">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-medium">Color: <span className="text-black/60">{colors.find(c => c.name === selectedColor)?.label}</span></span>
                </div>
                <div className="flex gap-3">
                  {colors.map(color => (
                    <button
                      key={color.name}
                      onClick={() => setSelectedColor(color.name)}
                      className={`w-10 h-10 md:w-12 md:h-12 rounded-full border-2 transition-all cursor-pointer flex items-center justify-center ${
                        selectedColor === color.name 
                          ? 'border-black' 
                          : 'border-black/10 hover:border-black/30'
                      }`}
                    >
                      <span 
                        className="w-6 h-6 md:w-8 md:h-8 rounded-full"
                        style={{ backgroundColor: color.hex }}
                      ></span>
                    </button>
                  ))}
                </div>
                <p className="text-xs text-black/50 mt-2">One size fits all</p>
              </div>

              {/* Quantity */}
              <div className="mb-6 md:mb-8">
                <span className="text-sm font-medium mb-3 block">Quantity</span>
                <div className="inline-flex items-center border border-black/10 rounded-lg">
                  <button 
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center hover:bg-black/5 transition-colors cursor-pointer"
                  >
                    <i className="ri-subtract-line text-base md:text-lg"></i>
                  </button>
                  <span className="w-10 md:w-12 text-center font-medium text-sm md:text-base">{quantity}</span>
                  <button 
                    onClick={() => setQuantity(Math.min(10, quantity + 1))}
                    className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center hover:bg-black/5 transition-colors cursor-pointer"
                  >
                    <i className="ri-add-line text-base md:text-lg"></i>
                  </button>
                </div>
              </div>

              {/* Trust Badges */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-6 border-t border-b border-black/10">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-black/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-truck-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-medium">Free Shipping</p>
                    <p className="text-[11px] text-black/50">Orders over €20</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-black/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-refresh-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-medium">30-Day Returns</p>
                    <p className="text-[11px] text-black/50">No questions asked</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-black/5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-medium">Secure Checkout</p>
                    <p className="text-[11px] text-black/50">SSL encrypted</p>
                  </div>
                </div>
              </div>

              {/* Payment Methods */}
              <div className="flex flex-wrap items-center gap-3 md:gap-4 mt-6">
                <span className="text-xs text-black/40">Pay with</span>
                <div className="flex items-center gap-2 md:gap-3">
                  <i className="ri-visa-line text-xl md:text-2xl text-black/40"></i>
                  <i className="ri-mastercard-line text-xl md:text-2xl text-black/40"></i>
                  <i className="ri-paypal-line text-xl md:text-2xl text-black/40"></i>
                  <i className="ri-apple-line text-xl md:text-2xl text-black/40"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Details Tabs */}
      <section className="px-4 md:px-20 py-12 md:py-16 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto">
          {/* Tab Headers */}
          <div className="flex gap-4 md:gap-8 border-b border-black/10 mb-8 md:mb-10 overflow-x-auto">
            {['description', 'how to use', 'reviews'].map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-3 md:pb-4 text-xs md:text-sm uppercase tracking-wider font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab 
                    ? 'text-black border-b-2 border-black' 
                    : 'text-black/40 hover:text-black/60'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          {activeTab === 'description' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
              <div>
                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6">Designed for Results</h3>
                <p className="text-sm md:text-[15px] text-black/70 leading-relaxed mb-4 md:mb-6">
                  The Jawline Support Strap is engineered for those who understand that small, consistent habits 
                  lead to visible improvements. Worn during sleep, it gently supports proper jaw positioning 
                  and encourages nasal breathing throughout the night. Suitable for both men and women.
                </p>
                <p className="text-sm md:text-[15px] text-black/70 leading-relaxed mb-6 md:mb-8">
                  Made from premium, breathable materials that stay comfortable for 8+ hours. 
                  Adjustable fit ensures it works for all head sizes without slipping or causing discomfort.
                </p>
                
                <h4 className="text-xs md:text-sm font-semibold uppercase tracking-wider mb-3 md:mb-4">Key Features</h4>
                <ul className="space-y-2 md:space-y-3">
                  {[
                    'Premium breathable fabric',
                    'Adjustable velcro closure',
                    'Lightweight design (45g)',
                    'Machine washable',
                    'One size fits most'
                  ].map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-sm text-black/70">
                      <i className="ri-check-line text-black"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              
              {/* Before/After Slider - Enhanced */}
              <div className="flex flex-col">
                <div className="bg-gradient-to-r from-black/5 to-transparent rounded-2xl p-4 md:p-6 mb-4">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-black flex items-center justify-center">
                      <i className="ri-contrast-2-line text-white text-sm md:text-base"></i>
                    </div>
                    <div>
                      <h4 className="text-sm md:text-base font-semibold">Real Results</h4>
                      <p className="text-xs text-black/50">Drag to compare before & after</p>
                    </div>
                  </div>
                </div>
                <div 
                  ref={sliderRef}
                  className="relative aspect-square rounded-2xl overflow-hidden cursor-ew-resize select-none shadow-2xl ring-4 ring-black/5"
                  onMouseDown={handleMouseDown}
                  onTouchMove={handleSliderMove}
                >
                  {/* After Image (Background) */}
                  <img 
                    src="https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/d84fa4b6934621c7537028e6c424c445.jpeg"
                    alt="After"
                    className="absolute inset-0 w-full h-full object-cover object-center"
                    draggable={false}
                  />
                  
                  {/* Before Image (Clipped) */}
                  <div 
                    className="absolute inset-0 overflow-hidden"
                    style={{ width: `${sliderPosition}%` }}
                  >
                    <img 
                      src="https://static.readdy.ai/image/07b995505c26827fb0d464fe2bd78fdd/aaec33fac423260c312d49d91ecf187c.jpeg"
                      alt="Before"
                      className="absolute inset-0 w-full h-full object-cover object-center"
                      draggable={false}
                    />
                  </div>
                  
                  {/* Slider Line */}
                  <div 
                    className="absolute top-0 bottom-0 w-1 bg-white shadow-2xl"
                    style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
                  >
                    {/* Slider Handle - Enhanced */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 bg-white rounded-full shadow-2xl flex items-center justify-center cursor-ew-resize ring-4 ring-black/10 hover:ring-black/20 transition-all">
                      <div className="flex items-center gap-0.5">
                        <i className="ri-arrow-left-s-line text-black text-base md:text-lg"></i>
                        <i className="ri-arrow-right-s-line text-black text-base md:text-lg"></i>
                      </div>
                    </div>
                  </div>
                  
                  {/* Labels - Enhanced */}
                  <div className="absolute bottom-4 md:bottom-5 left-4 md:left-5 bg-black text-white text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full font-medium shadow-lg">
                    Before
                  </div>
                  <div className="absolute bottom-4 md:bottom-5 right-4 md:right-5 bg-white text-black text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full font-medium shadow-lg">
                    After
                  </div>
                </div>
                <div className="flex items-center justify-center gap-2 mt-4 text-black/50">
                  <i className="ri-drag-move-2-line text-lg animate-pulse"></i>
                  <p className="text-xs md:text-sm font-medium">
                    Drag the slider to see the transformation
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'how to use' && (
            <div className="max-w-3xl">
              <h3 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8">Simple. Consistent. Effective.</h3>
              <div className="space-y-6 md:space-y-8">
                {[
                  { step: '01', title: 'Position', desc: 'Place the strap under your chin and bring both ends up over the top of your head.' },
                  { step: '02', title: 'Adjust', desc: 'Secure the velcro closure so it\'s snug but comfortable. You should be able to breathe normally through your nose.' },
                  { step: '03', title: 'Sleep', desc: 'Wear throughout the night. The strap will gently remind your jaw to stay closed, encouraging nasal breathing.' },
                  { step: '04', title: 'Repeat', desc: 'Consistency is key. Use every night for best results. Most users notice improvements within 2-4 weeks.' },
                ].map((item, idx) => (
                  <div key={idx} className="flex gap-4 md:gap-6">
                    <span className="text-2xl md:text-4xl font-light text-black/20">{item.step}</span>
                    <div>
                      <h4 className="text-base md:text-lg font-medium mb-2">{item.title}</h4>
                      <p className="text-sm md:text-[15px] text-black/60">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8 md:mb-10">
                <div>
                  <div className="flex items-center gap-3 md:gap-4 mb-2">
                    <span className="text-3xl md:text-5xl font-semibold">4.9</span>
                    <div>
                      <div className="flex items-center gap-1 mb-1">
                        {[1,2,3,4,5].map(star => (
                          <i key={star} className="ri-star-fill text-black text-sm md:text-base"></i>
                        ))}
                      </div>
                      <p className="text-xs md:text-sm text-black/50">Based on 127 reviews</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-4 md:space-y-6">
                {reviews.map((review, idx) => (
                  <div key={idx} className="bg-white p-4 md:p-6 rounded-xl">
                    <div className="flex items-start justify-between mb-3 md:mb-4">
                      <div className="flex items-center gap-2 md:gap-3">
                        <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-black/10 flex items-center justify-center flex-shrink-0">
                          <span className="text-xs md:text-sm font-medium">{review.name.charAt(0)}</span>
                        </div>
                        <div>
                          <p className="text-xs md:text-sm font-medium">{review.name}</p>
                          <div className="flex items-center gap-2">
                            <div className="flex items-center gap-0.5">
                              {[1,2,3,4,5].map(star => (
                                <i key={star} className={`ri-star-fill text-xs ${star <= review.rating ? 'text-black' : 'text-black/20'}`}></i>
                              ))}
                            </div>
                            {review.verified && (
                              <span className="text-[9px] md:text-[10px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded">Verified</span>
                            )}
                          </div>
                        </div>
                      </div>
                      <span className="text-[10px] md:text-xs text-black/40">{review.date}</span>
                    </div>
                    <p className="text-xs md:text-sm text-black/70 leading-relaxed">{review.text}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Social Proof Banner */}
      <section className="px-4 md:px-20 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="bg-black rounded-2xl p-8 md:p-12 text-white text-center">
            <p className="text-[10px] md:text-[11px] uppercase tracking-[0.2em] text-white/50 mb-3 md:mb-4">Trusted by 10,000+ customers</p>
            <h2 className="text-2xl md:text-3xl font-semibold mb-3 md:mb-4">Join the Discipline</h2>
            <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto mb-6 md:mb-8">
              Small habits compound over time. Start building yours today.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12">
              <div>
                <p className="text-3xl md:text-4xl font-semibold">98%</p>
                <p className="text-xs text-white/50 mt-1">Would recommend</p>
              </div>
              <div className="hidden sm:block w-px h-12 bg-white/20"></div>
              <div>
                <p className="text-3xl md:text-4xl font-semibold">4.9</p>
                <p className="text-xs text-white/50 mt-1">Average rating</p>
              </div>
              <div className="hidden sm:block w-px h-12 bg-white/20"></div>
              <div>
                <p className="text-3xl md:text-4xl font-semibold">24h</p>
                <p className="text-xs text-white/50 mt-1">Fast shipping</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="px-4 md:px-20 py-12 md:py-16 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-xl md:text-2xl font-semibold mb-6 md:mb-10">Complete Your Routine</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-product-shop>
            {[
              { 
                name: 'Nasal Breathing Strips', 
                price: '€19', 
                desc: 'Opens airways for better sleep',
                img: 'https://public.readdy.ai/ai/img_res/303e361e42cadba7cb55a391066472ea.jpg'
              },
              { 
                name: 'Posture Correction Band', 
                price: '€45', 
                desc: 'Supports proper alignment',
                img: 'https://readdy.ai/api/search-image?query=black-posture-correction-band-product-photography-clean-white-background-minimalist-aesthetic-premium-quality-material-professional-studio-lighting-modern-design-ecommerce-shot&width=500&height=600&seq=related-posture-002&orientation=portrait'
              },
              { 
                name: 'Complete Sleep Bundle', 
                price: '€79', 
                oldPrice: '€107',
                desc: 'Everything you need',
                img: 'https://readdy.ai/api/search-image?query=premium-sleep-wellness-bundle-product-photography-multiple-items-jaw-strap-nasal-strips-clean-white-background-minimalist-aesthetic-professional-studio-lighting-ecommerce-shot&width=500&height=600&seq=related-bundle-003&orientation=portrait'
              },
            ].map((product, idx) => (
              <div key={idx} className="group">
                <div className="aspect-[5/6] rounded-xl overflow-hidden bg-white mb-4 relative">
                  <img 
                    src={product.img} 
                    alt={product.name}
                    className="w-full h-full object-cover object-top blur-sm grayscale"
                  />
                  {/* Coming Soon Overlay */}
                  <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center">
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center mb-2 md:mb-3">
                      <i className="ri-time-line text-white text-2xl md:text-3xl"></i>
                    </div>
                    <span className="text-white text-xs md:text-sm font-semibold uppercase tracking-widest">Coming Soon</span>
                  </div>
                </div>
                <h3 className="text-sm font-medium mb-1 text-black/50">{product.name}</h3>
                <p className="text-xs text-black/30 mb-2">{product.desc}</p>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-black/50">{product.price}</span>
                  {product.oldPrice && (
                    <span className="text-xs text-black/20 line-through">{product.oldPrice}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
